module.exports = __webpack_public_path__ + "static/home-fb5e217a2a41c07677f429df73fb61c0.png";